import * as React from 'react';
import {
  IServiceItem,
  getRandomThreeItems,
  SALE_HEADING_TITLE,
  RENT_HEADING_TITLE,
  rentServices,
  SALE_SERVICES_TEST_ID,
  RENT_SERVICES_TEST_ID,
} from '../utils';
import { useSelector } from 'react-redux';
import { selectDealType } from '../../../selectors/page';
import { EDealType } from '../../../types/dealType';

export interface IUseServicesBlockProps {
  testId: string;
  headingTitle: string;
  items: IServiceItem[];
  showAllServicesButton: boolean;
  withoutBorder: boolean;
}

export const useServicesBlockProps = (): IUseServicesBlockProps => {
  const [randomThreeItems, setRandomThreeItems] = React.useState<IServiceItem[]>([]);

  const dealType = useSelector(selectDealType);

  React.useEffect(() => {
    const items = getRandomThreeItems();

    setRandomThreeItems(items);
  }, []);

  // Формирование пропсов для каждого типа сделки
  const testId = dealType === EDealType.Sale ? SALE_SERVICES_TEST_ID : RENT_SERVICES_TEST_ID;
  const headingTitle = dealType === EDealType.Sale ? SALE_HEADING_TITLE : RENT_HEADING_TITLE;
  const showAllServicesButton = dealType === EDealType.Sale;
  const items = dealType === EDealType.Sale ? randomThreeItems : rentServices;
  const withoutBorder = dealType !== EDealType.Sale;

  return {
    testId,
    headingTitle,
    items,
    showAllServicesButton,
    withoutBorder,
  };
};
